<div class="row" *ngIf="isComercial">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Site Beneficiamento</mat-label>
                                <mat-select #txtMotRepr formControlName="site_beneficiamento" disableCenteringOption
                                    class="InputBlockColor" disabled>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterSiteBeneficiamento($event.target.value)">
                                    <mat-option *ngFor="let item of listSiteBeneficiamento" [value]="item.initials">
                                        {{item.initials | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.site_beneficiamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote Cs</mat-label>
                                <input matInput id="txtLoteCs" (blur)="getQua042LotesTBFromLoteCS()" #txtLoteCs maxlength="10" formControlName="lote_cs">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtLoteCs.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_cs)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote Tb</mat-label>
                                <input matInput class="InputBlockColor" id="txtLoteTb" readonly #txtLoteTb maxlength="11" formControlName="lote_tb">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintLoteTb}}</mat-hint>
                                <mat-hint align="end">{{txtLoteTb.value.length}} / 10</mat-hint>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_tb)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data</mat-label>
                                <input matInput id="txtData" #txtData maxlength="10" mask="d0/M0/0000"
                                    formControlName="data_apontamento" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.data_apontamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Hora</mat-label>
                                <input matInput id="txtHora" #txtHora maxlength="5" mask="Hh:m0"
                                    formControlName="hora_apontamento" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.hora_apontamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                              <mat-label class="InputLabelColor">Safra</mat-label>
                              <mat-select #txtSafra  (selectionChange)="getDadosMateria()" formControlName="safra" disableOptionCentering>
                                <input matInput type="text" class="form-control filterTxt"
                                  placeholder="Pesquisar por..." (keyup)="createFilterSafra($event.target.value)">
                                <mat-option *ngFor="let item of listSafra" [value]="item.name">
                                  {{item.name | uppercase}}
                                </mat-option>
                              </mat-select>
                              <i matSuffix class="{{iconEnableField}}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                            </mat-form-field>
                        </div>
                    </div>



                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Híbrido</mat-label>
                                <mat-select #txtHibrido formControlName="hibrido_rnc" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterHibrido($event.target.value)">
                                    <mat-option *ngFor="let item of listHibrido" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.hibrido_rnc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Silo Origem</mat-label>
                                <mat-select #txtSiloOrigem formControlName="silo_origem" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Selecione um campo"
                                        (keyup)="createFilterPeneira($event.target.value)">
                                    <mat-option *ngFor="let item of listSiloOrigem" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.silo_origem)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peneira</mat-label>
                                <mat-select #txtPeneira formControlName="peneira" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterPeneira($event.target.value)">
                                    <mat-option *ngFor="let item of listPeneira" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.peneira)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg-6 col-md-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Equipamentos Utilizados</mat-label>
                                <mat-select #txtEquipUtil formControlName="equipamentos_utilizados"
                                    disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterEquipUtil($event.target.value)">
                                    <mat-option *ngFor="let item of listEquipUtil" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.equipamentos_utilizados)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Turno</mat-label>
                                <mat-select #txtTurno formControlName="turno" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..." (keyup)="createFilterTurno($event.target.value)">
                                    <mat-option *ngFor="let item of listTurno" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.turno)}}
                                </mat-error>
                            </mat-form-field>
                           </div>
                    </div>

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>


<!-- Básica -->

<div class="row" *ngIf="isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Número Campo</mat-label>
                                <input matInput id="txtNumeroCampo" #txtNumeroCampo maxlength="10"
                                    (blur)="getPC003Data()" formControlName="numero_campo" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtNumeroCampo.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.numero_campo)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                              <mat-label class="InputLabelColor">Safra</mat-label>
                              <mat-select #txtSafra  (selectionChange)="getDadosMateria()" formControlName="safra" disableOptionCentering>
                                <input matInput type="text" class="form-control filterTxt"
                                  placeholder="Pesquisar por..." (keyup)="createFilterSafra($event.target.value)">
                                <mat-option *ngFor="let item of listSafra" [value]="item.name">
                                  {{item.name | uppercase}}
                                </mat-option>
                              </mat-select>
                              <i matSuffix class="{{iconEnableField}}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                            </mat-form-field>
                        </div>

                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field *ngIf="!dropdownLoteds and listLoteDs.length == 0" class="w-100"
                                appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote DS / CS</mat-label>
                                <input matInput id="txtLoteCs" #txtLoteCs maxlength="11" formControlName="lote_cs">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtLoteCs.value.length}} / 11</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_cs)}}</mat-error>
                            </mat-form-field>
                            <mat-form-field *ngIf="dropdownLoteds and listLoteDs.length > 0" class="w-100"
                                appearance="{{ formFieldAppearance }}" floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Lote DS / CS</mat-label>
                                <mat-select #txtLoteCs formControlName="lote_cs" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterProcesso($event.target.value)" />
                                    <mat-option *ngFor="let item of listLoteDs" [value]="item.name">
                                        {{ item.name | uppercase }}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{ iconEnableField }}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{ hasErrorFormControl(formulario.controls.lote_cs) }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Linha de processamento</mat-label>
                                <mat-select #txtLinhaProcessamento formControlName="linha_processamento"
                                    disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Selecione um campo"
                                        (keyup)="createFilterPeneira($event.target.value)">
                                    <mat-option *ngFor="let item of listLinhaProcessamento" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.linha_processamento)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data</mat-label>
                                <input matInput id="txtData" #txtData maxlength="10" mask="d0/M0/0000"
                                    formControlName="data_apontamento" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.data_apontamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Hora</mat-label>
                                <input matInput id="txtHora" #txtHora maxlength="5" mask="Hh:m0"
                                    formControlName="hora_apontamento" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.hora_apontamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Site Beneficiamento</mat-label>
                                <mat-select #txtMotRepr formControlName="site_beneficiamento" disableCenteringOption
                                    class="InputBlockColor" disabled>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterSiteBeneficiamento($event.target.value)">
                                    <mat-option *ngFor="let item of listSiteBeneficiamento" [value]="item.initials">
                                        {{item.initials | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.site_beneficiamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Contrato Jurídico</mat-label>
                                <input matInput id="txtContratoJuridico" #txtContratoJuridico maxlength="20"
                                    formControlName="contrato_juridico" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtContratoJuridico.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.contrato_juridico)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Híbrido/Linhagem</mat-label>
                                <input matInput id="txtHibrido" #txtHibrido maxlength="40" formControlName="hibrido_rnc"
                                    readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.hibrido_rnc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Silo Origem</mat-label>
                                <mat-select #txtSiloOrigem formControlName="silo_origem" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Selecione um campo"
                                        (keyup)="createFilterPeneira($event.target.value)">
                                    <mat-option *ngFor="let item of listSiloOrigem" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.silo_origem)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peneira</mat-label>
                                <mat-select #txtPeneira formControlName="peneira_basica" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterPeneira($event.target.value)">
                                    <mat-option *ngFor="let item of listPeneiraBasica" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.peneira_basica)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Equipamentos Utilizados</mat-label>
                                <mat-select #txtEquipUtil formControlName="equipamentos_basica" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterEquipUtil($event.target.value)">
                                    <mat-option *ngFor="let item of listEquipUtilBasica" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.equipamentos_basica)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Geração</mat-label>
                                <input matInput id="txtGeracao" #txtGeracao maxlength="50" formControlName="geracao"
                                    readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtGeracao.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.geracao)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Prioridade</mat-label>
                                <input matInput id="txtprioridade" #txtprioridade maxlength="50"
                                    formControlName="prioridade" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtprioridade.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.prioridade)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>
